// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6339":"6c0b14162d84f8b6","7499":"e328e320bf87a33e"}[chunkId] + ".js";
};